import styled from "styled-components";

const Button = styled.button`
  padding: 3px 9px;
  margin: 0.5rem 0;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.02rem;
  line-height: 1.75;
  color: #fff;
  font-size: 0.8125rem;
  background-color: #2e85ec;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: #006ef1;
  }
  &:active {
    background-color: #004eff;
  }
`;
export default Button;
